import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"
import ApiServices from "../../services/api.service"

const apiServices = new ApiServices()

// Handle retrieve all
export const retrieveAllMember = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      status: data?.status || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/member/retrieve-all`,
        params,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
  }
)


export const deleteMember = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        url: `${BASEURI}/admin/member/delete/${id}`,
        headers: headers()
      },
      thunkAPI
    )
)


// retrieve all basic details of Member
export const retrieveMemberInfo = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const { userId, ...params } = data;

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/member/retrieve/${userId}/info`,
        params,
        headers: headers(),
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data",
      }
    );
  }
);

// retrieve single  members details
export const retrieveMember = createAsyncThunk(
  "retrieveSingle",
  async (data, thunkAPI) => {
    const { userId, ...params } = data;

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/member/retrieve/${userId}`,
        params,
        headers: headers(),
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data",
      }
    );
  }
);



// retrieve all Specialists of members
export const retrieveMemberSepcialists = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const { userId, ...params } = data;

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/member/retrieve/${userId}/specialists`,
        params,
        headers: headers(),
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data",
      }
    );
  }
);

// retrieve all appointments of members
export const retrieveMemberAppointments = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const { userId, ...params } = data;

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/member/retrieve/${userId}/appointments`,
        params,
        headers: headers(),
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data",
      }
    );
  }
);
//staus update
export const updateMembertStatus = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    asyncThunkWrapper(
      {
        method: "PUT",
        url: `${BASEURI}/admin/member/update/${data?.id}/status`,
        data: {
          status: data?.status,
          reason: data?.reason,
        }, headers: headers()
      },
      thunkAPI
    )

  }
)

// ---------------  ---------------
export const _updateMembertStatus = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    return apiServices.request(
      {
        method: "PUT",
        url: `${BASEURI}/admin/member/update/${data?.id}/status`,
        data: {
          status: data?.status,
          reason: data?.reason,
        }, headers: headers()
      },
      thunkAPI
    )

  }
)